import { UserRole } from "@services/http/responses/AccountResponse";
import AUTHSTATES from "./AuthStates";

export enum ActionTypesAuthE {
  INIT = "INIT",
  // SET_AUTH = "SET_AUTH",
  UPDATE_AUTH = "UPDATE_AUTH",
  LOGOUT = "LOGOUT",
  CLEAR_AUTH = "CLEAR_AUTH",
}

export interface ActionBaseAuth {
  type: ActionTypesAuthE;
  payload?: any;
}

export interface IAuthorization {
  id: number;
  email: {
    isPrivate: boolean;
    value: string;
  };
  name: string;
  state: AUTHSTATES;
  isAdmin: boolean;
  role: UserRole;
  uuid: string;
  controllerId?: string;

  m_online: number;
  m_offline: number;
  m_low: number;
}
/*
export interface ActionSetAuth extends ActionBaseAuth {
  payload: IAuthorization;
} */

export interface ActionUpdateAuth extends ActionBaseAuth {
  payload: IAuthorization;
}
